import { SidebarTagProps } from "components/templates/TagsSidebar";
import { useCreateMappingDeviceTagsMutation } from "graphqlBase/MappingDeviceTag/__generated__/createMappingDeviceTags";
import { GetMappingDeviceTagsDocument } from "graphqlBase/MappingDeviceTag/__generated__/getMappingDeviceTags";
import { useCreateTagsMutation } from "graphqlBase/Tag/__generated__/createTags";
import { GetTagsDocument } from "graphqlBase/Tag/__generated__/getTags";
import { MappingDeviceTagCreateType } from "graphqlBase/types";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { deviceTagsforTagsListAtom, deviceTagsToCreateAtom } from "../recoilState/deviceTagsState";
import { assignedDeviceTagErrorAtom } from "../recoilState/tagModalState";
import { MappingDeviceTag } from "..";

const useCreateDeviceTags = ({ selectedDeviceIds }: { selectedDeviceIds: string[] | undefined }) => {
  const createTags = useRecoilValue(deviceTagsToCreateAtom);
  const deviceTagsForTagsList = useRecoilValue(deviceTagsforTagsListAtom);
  const setAssignedDeviceTagError = useSetRecoilState(assignedDeviceTagErrorAtom);

  const [
    createMappingDeviceTagsMutation,
    { loading: createMappingDeviceTagsLoading },
  ] = useCreateMappingDeviceTagsMutation({
    refetchQueries: [{ query: GetMappingDeviceTagsDocument }],
  });

  const [createDeviceTagsMutation, { loading: createDeviceTagsLoading }] = useCreateTagsMutation({
    refetchQueries: [{ query: GetTagsDocument }],
  });

  const isNotNewTag = (tag: SidebarTagProps) => {
    return tag.id !== undefined;
  };

  const handleCreateDeviceTags = async ({ mappingDeviceTags }: { mappingDeviceTags: MappingDeviceTag[] }) => {
    if (!selectedDeviceIds?.length) return;
    try {
      const { data } = await createDeviceTagsMutation({ variables: { createTags } });
      const createMappingDeviceTags = selectedDeviceIds.reduce(
        (accDevice: MappingDeviceTagCreateType[], currDeviceId) => {
          const selectedTags = (deviceTagsForTagsList ?? []).filter(isNotNewTag);

          const temp = selectedTags.reduce((accChip: MappingDeviceTagCreateType[], currTag) => {
            if (!currTag.id) return accChip;
            const index = mappingDeviceTags.findIndex(
              (entry) => entry.deviceId === currDeviceId && entry.tagId === currTag.id
            );
            if (index === -1) return accChip.concat({ tagId: currTag.id, deviceId: currDeviceId });
            return accChip;
          }, []);

          const newMappings: MappingDeviceTagCreateType[] =
            data?.createTags?.map((newTag) => {
              return { tagId: newTag?.id ?? "", deviceId: currDeviceId };
            }) ?? [];

          const allMappings = temp.concat(newMappings);

          return accDevice.concat(allMappings);
        },
        []
      );

      if (mappingDeviceTags.length > 0) {
        await createMappingDeviceTagsMutation({
          variables: { createMappingDeviceTags },
        });
      }
    } catch (error) {
      setAssignedDeviceTagError("This tag is already assigned");
      setTimeout(() => {
        setAssignedDeviceTagError(undefined);
      }, 3000);
    }
  };

  return {
    createDeviceTagsLoading: createDeviceTagsLoading || createMappingDeviceTagsLoading,
    handleCreateDeviceTags,
  };
};

export default useCreateDeviceTags;
